import { CONNECTION_APP_SECTIONS } from './connectionAppsCatalogSections.js'

/** @param {string | undefined} slug */
export function findConnectionAppBySlug(slug) {
  if (!slug || typeof slug !== 'string') return null
  const normalized = decodeURIComponent(slug).toLowerCase()
  for (const section of CONNECTION_APP_SECTIONS) {
    const app = section.apps.find((a) => a.slug === normalized)
    if (app) return { ...app, sectionTitle: section.title }
  }
  return null
}
